import { render } from "./CustomStyles.vue?vue&type=template&id=01e0e120&scoped=true"
import script from "./CustomStyles.vue?vue&type=script&lang=js"
export * from "./CustomStyles.vue?vue&type=script&lang=js"

import "./CustomStyles.vue?vue&type=style&index=0&id=01e0e120&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01e0e120"

export default script